module.exports.main_scroll_area_jump_to = (selector) => {

	let DOM_main_scroll_area;

	DOM_main_scroll_area = document.getElementById(`main_scroll_area`);
	
	if(!DOM_main_scroll_area === null) {
		throw new Error('assertion fail: main scroll area not find');		
	}
	
	let DOM_jump_to;

	DOM_jump_to = document.querySelector(selector);
	
	if(DOM_jump_to === null) return;
	
	DOM_jump_to.scrollIntoView({ behavior: "smooth" });

}
